import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

const TOKEN_KEY = "ceg_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export default client;

export const publicApi = axios.create({ baseURL: API });

// Public
export const fetchCategories = () => publicApi.get("/categories").then((r) => r.data);
export const fetchCategory = (slug) => publicApi.get(`/categories/${slug}`).then((r) => r.data);
export const fetchArticles = (params = {}) =>
  publicApi.get("/articles", { params }).then((r) => r.data);
export const fetchFeatured = (limit = 6) =>
  publicApi.get("/articles/featured", { params: { limit } }).then((r) => r.data);
export const fetchLatest = (limit = 8) =>
  publicApi.get("/articles/latest", { params: { limit } }).then((r) => r.data);
export const fetchArticleBySlug = (slug) =>
  publicApi.get(`/articles/by-slug/${slug}`).then((r) => r.data);
export const fetchTags = () => publicApi.get("/tags").then((r) => r.data);
export const fetchAuthor = (slug) => publicApi.get(`/authors/${slug}`).then((r) => r.data);
export const submitContact = (body) =>
  publicApi.post("/contact", body).then((r) => r.data);
export const subscribeNewsletter = (email) =>
  publicApi.post("/newsletter", { email }).then((r) => r.data);

// Admin
export const adminLogin = (email, password) =>
  publicApi.post("/admin/login", { email, password }).then((r) => r.data);
export const adminMe = () => client.get("/admin/me").then((r) => r.data);
export const adminStats = () => client.get("/admin/stats").then((r) => r.data);
export const adminListArticles = (q) =>
  client.get("/admin/articles", { params: q ? { q } : {} }).then((r) => r.data);
export const adminGetArticle = (id) => client.get(`/admin/articles/${id}`).then((r) => r.data);
export const adminCreateArticle = (body) =>
  client.post("/admin/articles", body).then((r) => r.data);
export const adminUpdateArticle = (id, body) =>
  client.patch(`/admin/articles/${id}`, body).then((r) => r.data);
export const adminDeleteArticle = (id) =>
  client.delete(`/admin/articles/${id}`).then((r) => r.data);
export const adminGenerateArticle = (body) =>
  client.post("/admin/articles/generate", body).then((r) => r.data);
export const adminContactSubmissions = () =>
  client.get("/admin/contact-submissions").then((r) => r.data);
export const adminNewsletter = () =>
  client.get("/admin/newsletter-signups").then((r) => r.data);
export const adminSchedulerStatus = () =>
  client.get("/admin/scheduler/status").then((r) => r.data);
export const adminSchedulerRunNow = (spotlight = false) =>
  client.post("/admin/scheduler/run-now", null, { params: { spotlight } }).then((r) => r.data);
export const adminSchedulerRunDaily = () =>
  client.post("/admin/scheduler/run-daily").then((r) => r.data);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
